(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('LoginController', LoginController);

  /* ngInject */
  function LoginController($state, authenticationService, meService, sessionService) {
    const vm = this;

    vm.alert = null;
    vm.loading = false;
    vm.logIn = logIn;
    vm.authenticateWithPassword = authenticateWithPassword;
    vm.loginForm = {};
    vm.resetFormErrors = resetFormErrors;
    vm.authenticatedWithPassword = false;
    vm.user = {};

    function authenticateWithPassword() {      
      authenticationService(sessionService.getAuthToken()).authenticateWithPassword(vm.user, passwordSuccess, passwordFailure);
    }

    function passwordSuccess(response) {
      const user = response;
      sessionService.setUser(user);
      logInSuccess(response)
      //vm.authenticatedWithPassword = true;
    }

    function passwordFailure(response) {
      vm.loading = false;
      vm.alert = response.data.error_msg;
    }

    function logIn() {
      vm.loading = true;
      authenticationService(sessionService.getAuthToken()).authenticate(vm.user, logInSuccess, logInFailure);
    }

    function logInSuccess(response) {
      sessionService.setAuthToken(response.auth_token);
      getMe();
    }

    function logInFailure(response) {
      vm.loading = false;
      vm.alert = response.data.error;
    }

    function getMe() {
      meService(sessionService.getAuthToken()).get(getMeSuccess, getMeFailure);
    }

    function getMeSuccess(response) {
      vm.loading = false;

      const user = response;
      sessionService.setUser(user);
      sessionService.setProductRoles(response.product_roles);
      $state.go('application.compliance_framework.dashboard');
    }

    function getMeFailure() {
      vm.loading = false;
    }

    function resetFormErrors() {
      vm.alert = null;
    }
  }
})();
